import {UNIT} from '@di-shared/const';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {useSuspenseQuery} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {diApi} from '@di-shared/api/di';
import UbiDiscountBannerKr from '@di-shared/features/home/kr/benefit/UbiDiscountBanner.kr';
import {useNavigate} from 'react-router';
import {ROUTE_PATHS} from '@di-shared/routes';
import {emitEventLog} from '@di-shared/features/analytics';
import ImageSelector from '@di-shared/features/common/ImageSelector';

export interface UbiSectionKrProps {
  vin: string;
}

function UbiSectionKr({vin}: UbiSectionKrProps) {
  const {t} = useInferableTranslation();
  const navigate = useNavigate();
  const {data: maxDiscountRate} = useSuspenseQuery({
    queryKey: [getQueryKey(diApi.specialInsuranceContractController.getMaxDiscountRate)],
    queryFn: () => diApi.specialInsuranceContractController.getMaxDiscountRate(),
  });

  return (
    <section className="section section_ubi">
      <div className="section_container">
        <div className="section_container_header">
          <div className="container_header_title">
            <h3 className="label_medium_b">{t('T20019')}</h3>
            <strong className="title_xxsmall">{t('T10137')}</strong>
          </div>
          <div className="container_header_imgbox">
            <ImageSelector
              alt="ubi-discount-logo"
              kiaLightSrc={() => import('@di-shared/assets/img/home/ubi_discount_light.png')}
              kiaDarkSrc={() => import('@di-shared/assets/img/home/ubi_discount.png')}
              hyundaiLightSrc={() => import('@di-shared/assets/img/home/hyundai/ubi_discount_light.png')}
              hyundaiDarkSrc={() => import('@di-shared/assets/img/home/hyundai/ubi_discount.png')}
              genesisLightSrc={() => import('@di-shared/assets/img/home/genesis/ubi_discount_light.png')}
              genesisDarkSrc={() => import('@di-shared/assets/img/home/genesis/ubi_discount.png')}
            />
          </div>
        </div>
        <ul className="ubi_discount_list">
          <li className="ubi_discount_item">
            <div className="ubi_discount_icon">
              <span className="ic ic_fuel_efficiency_20px" />
            </div>
            <span className="ubi_discount_title">{t('T10138')}</span>
            <span className="ubi_discount_rate">
              {t('T10139')} <em className="text_emphasis">{maxDiscountRate.data.safeDrivingScoreMaxDiscount}</em>
              {UNIT.PERCENT}
            </span>
            <UbiDiscountBannerKr vin={vin} />
          </li>

          <li className="ubi_discount_item">
            <div className="ubi_discount_icon">
              <span className="ic ic_share_20px" />
            </div>
            <span className="ubi_discount_title">{t('T10144')}</span>
            <span className="ubi_discount_rate">
              {t('T10139')}
              <em className="text_emphasis">{maxDiscountRate.data.connectedCarSubscriptionMaxDiscount}</em>
              {UNIT.PERCENT}
            </span>
          </li>
          <li className="ubi_discount_item">
            <div className="ubi_discount_icon">
              <span className="ic ic_location_20px" />
            </div>
            <span className="ubi_discount_title">{t('T10145')}</span>
            <span className="ubi_discount_rate">
              {t('T10139')} <em className="text_emphasis">{maxDiscountRate.data.mileageMaxDiscount}</em>
              {UNIT.PERCENT}
            </span>
          </li>
          {/* [2024-12-06:dooking] FIXME: 서연님 요청에 의해 삭제, 첨단안전장치 기능 추가될 때 다시 주석제거 */}
          {/* @link https://hmg.dooray.com/project/tasks/3951007619092201538 */}
          {/*<li className="ubi_discount_item">*/}
          {/*  <div className="ubi_discount_icon">*/}
          {/*    <span className="ic ic_svm_all_20px" />*/}
          {/*  </div>*/}
          {/*  <span className="ubi_discount_title">{t('T10146')}</span>*/}
          {/*  <span className="ubi_discount_rate">*/}
          {/*    {t('T10139')} <em className="text_emphasis">{maxDiscountRate.data.advancedDeviceMaxDiscount}</em>*/}
          {/*    {UNIT.PERCENT}*/}
          {/*  </span>*/}
          {/*</li>*/}
        </ul>

        <button
          className="btn btn_large btn_filled btn_full"
          type="button"
          onClick={() => {
            emitEventLog({
              event: 'insurance_deals',
              form_step: 'view more',
              click_text: t('T10147'),
              click_location: 'body',
            });
            navigate(ROUTE_PATHS.UBI.getFullPath(vin));
          }}
        >
          {t('T10147')}
        </button>
      </div>

      <p className="notice_desc">{t('T10148')}</p>
    </section>
  );
}

export default UbiSectionKr;
